import { Headers } from '@egw/components'
import { TransactionDetails } from '@egw/features-transactions'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'
import { useParams } from 'react-router'

export const SavingsActivityDetailsPage: FC = () => {
  const { t } = useTranslation()

  const { alias, transactionId } = useParams<{ alias: string; transactionId: string }>()

  return alias && transactionId ? (
    <Layout>
      <Headers title={t('pages.savings.title')} />
      <TransactionDetails alias={parseInt(alias)} transactionId={transactionId} />
    </Layout>
  ) : null
}
